import { useQuery } from "@tanstack/react-query";
import postsMediaAPI from "../../api/posts-media/api";

export function getQueryKey() {
  return ["posts-media"];
}

export function useGetPostsMedia() {
  return useQuery({
    queryKey: getQueryKey(),
    queryFn: postsMediaAPI.getPostsMedia,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
